<form [formGroup]="checkoutFormGroup" (ngSubmit)="onSubmitForm()" #myForm="ngForm">
  <section class="summary-sect">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 chk-frm">
          <div class="contact-details">
            <h2>{{"tripCheckoutPage.contacDetails" | i18n}}</h2>
            <p>{{"tripCheckoutPage.noteContact" | i18n}}</p>
            <div class="cf-field">
              <div class="form-field">
                <div class="fname">
                  <label for="fname">{{"tripCheckoutPage.firstName" | i18n}}</label>
                  <input name="fname" id="fname" type="text" formControlName="firstNameContactControl" />
                  <div *ngIf="
                      this.firstNameContactControl.invalid &&
                      (this.firstNameContactControl.dirty || this.firstNameContactControl.touched)
                    " class="errorText">
                    {{ checkError(this.firstNameContactControl,'checkoutPage.formFields.firstName.requiredMessage') | i18n}}
                  </div>
                </div>
                <div class="lname">
                  <label for="lname">{{"tripCheckoutPage.lastName" | i18n}}</label>
                  <input name="lname" id="lname" type="text" formControlName="lastNameContactControl" />
                  <div *ngIf="
                      this.lastNameContactControl.invalid &&
                      (this.lastNameContactControl.dirty || this.lastNameContactControl.touched)
                    " class="errorText">
                    {{ checkNameError(this.lastNameContactControl) | i18n}}
                  </div>
                </div>
              </div>
              <div class="form-field">
                <div class="mob-no">
                  <label for="mobile-no">{{"tripCheckoutPage.mobileNumber" | i18n}}</label>
                  <p>
                    <input id="mobile-no" name="mobile-no" type="tel"
                      formControlName="mobileNoContactControl" />
                  </p>
                  <div *ngIf="mobileNoContactControl.invalid && (mobileNoContactControl.dirty || mobileNoContactControl.touched)">
                    <div *ngIf="mobileNoContactControl.hasError('required'); else invalidPhoneError" class="errorText">
                      {{ 'checkoutPage.formFields.phoneNumber.requiredMessage' | i18n }}
                    </div>
                    <ng-template #invalidPhoneError>
                      <div *ngIf="mobileNoContactControl.hasError('invalidPhone')" class="errorText">
                        {{ 'checkoutPage.formFields.phoneNumber.errorMessage' | i18n }}
                      </div>
                    </ng-template>
                  </div>
                </div>
                <div class="email">
                  <label for="email">{{"tripCheckoutPage.email" | i18n}}</label>
                  <input name="email" id="email" type="email" formControlName="emailContactControl" />
                  <div *ngIf="
                      this.emailContactControl.invalid &&
                      (this.emailContactControl.dirty || this.emailContactControl.touched)
                    " class="errorText">
                    {{ checkError(this.emailContactControl,'checkoutPage.formFields.email.requiredMessage') | i18n }}
                  </div>
                  <div *ngIf="
                      this.emailContactControl.invalid && this.emailContactControl.touched" class="errorText">
                    {{ checkValidEmailError(this.emailContactControl) | i18n }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="passenger-detail">
            <h2>{{"tripCheckoutPage.passengerDetails" | i18n}}</h2>
            <div class="notice">
              <img src="assets/images/danger.png">
              <span>{{"tripCheckoutPage.notePassenger" | i18n}}</span>
            </div>
            <div class="cf-field" *ngFor="let _ of paxFormGroups; let i = index" [formGroup]="_">
              <div class="form-field rd-fld">
                <input type="radio" id="adult{{ i }}"  value="adult" formControlName="type" />
                <label for="adult{{ i }}">{{'homePage.searchForm.adults' | i18n}}</label>
                <input type="radio" id="child{{ i }}"  value="child" formControlName="type" />
                <label for="child{{ i }}">{{'homePage.searchForm.child' | i18n}}</label>
              </div>
              <div *ngIf="_.get('type').invalid && (_.get('type').dirty || _.get('type').touched)" class="errorText">
                {{ checkTypeError(_.get('type')) | i18n}}
              </div>
              <div class="form-field passengerFields">
                <div class="fname-adlchl">
                  <label for="fname-adlchl{{ i }}">{{"tripCheckoutPage.firstMiddleName" | i18n}}</label>
                  <input name="fname-adlchl{{ i }}" type="text"
                    formControlName="firstAndMiddleName" />
                  <div *ngIf="
                      _.get('firstAndMiddleName').invalid &&
                      (_.get('firstAndMiddleName').dirty || _.get('firstAndMiddleName').touched)
                    " class="errorText">
                    {{ checkNameError(_.get('firstAndMiddleName')) | i18n }}
                  </div>
                </div>

                <div class="lname-adlchl">
                  <label for="lname-adlchl{{ i }}">{{"tripCheckoutPage.lastName" | i18n}}</label>
                  <input name="lname-adlchl{{ i }}" type="text" formControlName="lastName" />
                  <div *ngIf="
                      _.get('lastName').invalid &&
                      (_.get('lastName').dirty || _.get('lastName').touched)
                    " class="errorText">
                    {{ checkLastNameError(_.get('lastName')) | i18n }}
                  </div>
                </div>
              </div>
              <div class="form-field">
                <div class="dob">
                  <label for="dob{{ i }}">{{"tripCheckoutPage.dob" | i18n}}</label>
                  <input name="dob{{ i }}" type="date" placeholder="mm/dd/yyyy" formControlName="dob" />
                  <div *ngIf="_.get('dob').invalid && (_.get('dob').dirty || _.get('dob').touched)" class="errorText">
                    {{ checkDobError(_.get('dob')) | i18n }}
                  </div>
                  <div *ngIf="_.get('dob').invalid && (_.get('dob').dirty || _.get('dob').touched)" class="errorText">
                    {{checkDobInvalidError(_.get('dob')) | i18n}}
                  </div>
                  <div *ngIf="_.get('dob').invalid && (_.get('dob').dirty || _.get('dob').touched)" class="errorText">
                    {{checkDobNotAdultError(_.get('dob')) | i18n }}
                  </div>
                </div>
                <div class="nationality passengerFields">
                  <label for="nationality{{ i }}">{{"tripCheckoutPage.nationality" | i18n}}</label>
                  <select name="nationality{{ i }}" id="nationality{{ i }}" formControlName="nationality">
                    <option value="">
                      <span class="option">please select</span>
                    </option>
                    <option *ngFor="let data of this.countries" [value]="data.name">
                      <span class="option">{{ data.name }}</span>
                    </option>
                  </select>
                  <div *ngIf="
                      _.get('nationality').invalid &&
                      (_.get('nationality').dirty || _.get('nationality').touched)
                    " class="errorText">
                    {{ checkNationalityError(_.get('nationality')) | i18n }}
                  </div>
                </div>
              </div>
              <div class="form-field">
                <div class="city-adlchl">
                  <label for="city-adlchl{{ i }}">{{ "tripCheckoutPage.city" | i18n }}</label>
                  <input name="city-adlchl{{ i }}" type="text" formControlName="city" />
                  <div
                    *ngIf="
                      _.get('city').invalid &&
                      (_.get('city').dirty || _.get('city').touched)
                    "
                    class="errorText"
                  >
                    {{ checkCityError(_.get('city')) | i18n }}
                  </div>
                </div>  
                <div class="passport-nmbr passengerFields">
                  <label for="passport-nmbr{{ i }}">{{"tripCheckoutPage.passportNumber" | i18n}}</label>
                  <input name="passport-nmbr{{ i }}" type="text" placeholder="1234567" formControlName="passportNumber" />
                  <div *ngIf="
                      _.get('passportNumber').invalid &&
                      (_.get('passportNumber').dirty || _.get('passportNumber').touched)
                    " class="errorText">
                    {{ checkPassportError(_.get('passportNumber')) | i18n}}
                  </div>
                </div>
              </div>  
            </div>
          </div>

          <div class="passenger-detail coupon-code">
            <h2>{{"tripCheckoutPage.haveCode" | i18n}}</h2>
            <div class="cf-field">
              <div class="form-field">
                <div class="cp-code-fld">
                  <label>{{"tripCheckoutPage.couponLabel" | i18n}}</label>
                  <div class="cp-code" >
                    <input type="text" formControlName="couponControl" (input)="enableApply($event)"/>
                    <button type="button" class="apply" (click)="onHandleCoupon()" [ngClass]="{'disabled': couponInput}" [disabled]="couponInput">
                      <span *ngIf="isApplying" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span *ngIf="!isApplying">  {{"tripCheckoutPage.btnApply" | i18n}}</span>
                      <span *ngIf="isApplying">{{"tripCheckoutPage.btnApplying" | i18n}}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="couponDetail">
                <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
                  <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                  </symbol>
                  <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </symbol>
                  <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                  </symbol>
                </svg>
                <div *ngIf="!this.isCouponValid; else elseCouponValid" class="alert alert-danger d-flex align-items-center" role="alert">
                  <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg>
                  <div>
                    {{"tripCheckoutPage.invalid" | i18n}}
                  </div>
                </div>
                <ng-template #elseCouponValid >
                  <div class="alert alert-success d-flex align-items-center" role="alert">
                    <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg>
                    <div>
                      {{"tripCheckoutPage.valid" | i18n}}
                    </div>
                  </div>
                </ng-template>
                  
              </div>
            </div>
          </div>
          <div class="passenger-detail payment-select wtp">
            <h2>{{"tripCheckoutPage.waysToPay" | i18n}}</h2>
            <div class="cf-field">
              <div class="radio-field">
                <label>
                  <input type="radio" id="payfull" name="payment" value="payfull" />
                  <span></span>
                </label>
                <div class="payfull">
                  <div class="titledsc">
                    <h2>{{"tripCheckoutPage.payFull" | i18n}}</h2>
                    <p>{{"tripCheckoutPage.payFullNote" | i18n}}</p>
                  </div>
                  <div class="price">
                    <p>$3,549</p>
                  </div>
                </div>
              </div>
              <div class="radio-field">
                <label>
                  <input type="radio" id="payfull" name="payment" value="payfull" />
                  <span></span>
                </label>
                <div>
                  <div class="titledsc title-pr">
                    <div class="cont">
                      <h2>{{"tripCheckoutPage.pay35" | i18n}}</h2>
                      <p>
                        {{"tripCheckoutPage.pay35Note" | i18n}}
                      </p>
                    </div>
                    <div class="price">
                      <p>$1,242</p>
                    </div>
                  </div>
                  <div class="titledsc title-pr">
                    <div class="cont">
                      <p>{{"tripCheckoutPage.remainingPay" | i18n}}</p>
                    </div>
                    <div class="price">
                      <p>$2,307</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="passenger-detail payment-select fp">
            <h2>{{"tripCheckoutPage.finalPayment" | i18n}}</h2>
            <div class="notice">
              <img src="assets/images/secure.svg">
              <p>
                {{"tripCheckoutPage.secureCheckout" | i18n}}<span>{{"tripCheckoutPage.secureCheckoutNote" | i18n}}</span>
              </p>
            </div>
            <div class="cf-field">
              <div class="form-field">
                <div class="card-number">
                  <label for="card-number">{{"tripCheckoutPage.cardNumber" | i18n}}</label>
                  <input name="card-number" type="text" placeholder="0000 0000 0000 0000" />
                </div>
              </div>
              <div class="form-field inline">
                <div class="card-number">
                  <label for="expiration">{{"tripCheckoutPage.expiration" | i18n}}</label>
                  <input name="expiration" type="text" placeholder="MM / YY" />
                </div>
                <div class="expiration-cvc">
                  <label for="cvc">CVV</label>
                  <input name="cvc" type="text" placeholder="123" />
                </div>
              </div>
              <div class="payment-method-pick">
                <div class="gpay">
                  <div class="payment-title">
                    <label class="cst-radio">
                      <input type="radio" name="payment" />
                      <span>Google Pay</span>
                    </label>
                  </div>
                  <img src="assets/images/gpay.svg">
                </div>
                <div class="apple-pay">
                  <div class="payment-title">
                    <label class="cst-radio">
                      <input type="radio" name="payment" />
                      <span>Apple Pay</span>
                    </label>
                  </div>
                  <img src="assets/images/apple_pay.png">
                </div>
                <div class="paypal">
                  <div class="payment-title">
                    <label class="cst-radio">
                      <input type="radio" name="payment" />
                      <span>Paypal</span>
                    </label>
                  </div>

                  <img src="assets/images/paypal.png" />
                </div>
              </div>
              <div class="pay-btn" *ngIf="!loadedOrderInfoFlag">
                <button [disabled]="isLoading" type="submit" *ngIf="isLoading">
                  {{'tripCheckoutPage.btnProcessing' | i18n}}</button>
                <button [disabled]="isLoading" type="submit" *ngIf="!isLoading">
                  {{'tripCheckoutPage.btnPay' | i18n}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 sum-frm">
          <div class="trip-summary trip-summary-bg">
            <h2>{{"tripCheckoutPage.summaryCard.tripSummary" | i18n}}</h2>
            <div class="item" *ngIf="loadedFlightFlag">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.flyingFrom" | i18n}}</p>
              <p class="main-val">
                {{ parseLocation(loadedFlight.slices[0].segments[0].origin) }}
              </p>
            </div>
            <div class="item" *ngIf="loadedHotelFlag">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.resort" | i18n}}</p>
              <p class="main-val">{{ this.loadedHotel.name }}</p>
            </div>
            <div class="item">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.from" | i18n}}</p>
              <p class="main-val">{{ (this.data.inboundDate ? this.data.inboundDate :
                (isObjectNotEmpty(this.loadedOrderInfo) ? this.loadedOrderInfo.dates.from : '')) | date : 'dd/MM/yyyy'
                }}</p>
            </div>
            <div class="item">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.to" | i18n}}</p>
              <p class="main-val">
                {{ (this.data.outboundDate ? this.data.outboundDate : (isObjectNotEmpty(this.loadedOrderInfo) ?
                this.loadedOrderInfo.dates.to : '')) | date : 'dd/MM/yyyy' }}
              </p>
            </div>
            <div class="item bd">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.groupSize" | i18n}}</p>
              <p class="main-val">
                {{ totalMembers }}
                <span *ngIf="totalMembers < 2">{{ 'tripCheckoutPage.summaryCard.member' | i18n }}</span>
                <span *ngIf="totalMembers >= 2">{{ 'tripCheckoutPage.summaryCard.members' | i18n }}</span>
              </p>
            </div>
            <h2>{{"tripCheckoutPage.summaryCard.priceDetail" | i18n}}</h2>

            <div class="item" *ngIf="loadedEventFlag">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.pakage" | i18n}} <br> {{"tripCheckoutPage.summaryCard.eventInclusive" | i18n}}</p>
              <p class="main-val" *ngIf="totalPackagePrice">
                {{
                totalPackagePrice
                | currencyConverter123 | async
                }}
              </p>
            </div>
            <div class="item" *ngIf="flightPrice">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.flight" | i18n}}</p>
              <p class="main-val">
                {{ flightPrice | currencyConverter123 | async }}
              </p>
            </div>
            <div class="item" *ngIf="hotelPrice">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.hotel" | i18n}}</p>
              <p class="main-val">
                {{
                hotelPrice | currencyConverter123 | async
                }}
              </p>
            </div>
            <div class="item bd">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.bookingFee" | i18n}}</p>
              <p class="main-val">Free</p>
            </div>

            <div class="item bd" *ngIf="this.discount > 0">
              <p class="main-head">Discount</p>
              <p class="main-val">{{ '  -' + this.discount | currencyConverter123 | async }}</p>
            </div>
            <div class="item price">
              <p class="main-head">{{"tripCheckoutPage.summaryCard.total" | i18n}}</p>
              <p class="main-val">
                {{ (this.totalCost - discount > 0 ? this.totalCost - discount : 0) | currencyConverter123 | async }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</form>
<div *ngIf="typopup" [ngClass]="{ 'view-order': true, typopup: true }" appOutside (click)="ClickedOutty($event)">
  <div class="vo-container container">
    <div class="close-popup">
      <svg (click)="closePopupty()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
        fill="none">
        <g opacity="0.5">
          <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </g>
      </svg>
    </div>
    <div class="row">
      <div class="col-lg-12 text-center logo-image">
        <img class="desktopimg" src="assets/images/tylogo.png" />
        <img class="mobimg" src="assets/images/tylogo-mob.png" />
      </div>
      <div class="col-lg-12 tycontent">
        <h2>{{"tripCheckoutPage.summaryCard.orderMessageSuccessA" | i18n}}{{this.orderId+" "}}{{"tripCheckoutPage.summaryCard.orderMessageSuccessB" | i18n}}</h2>
        <p>{{"tripCheckoutPage.summaryCard.orderNote" | i18n}}😊</p>
        <div class="cont-btn">
          <button (click)="closePopupty()">{{"tripCheckoutPage.summaryCard.continueBtn" | i18n}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
